<template>
  <div class="kye-report-fzkp001" @click="handleClick('cardClick')">
    <div class="fzkp001_main-cell-title">
      <div
        class="fzkp001_main-title"
        @click="handleClick('mainTitle')"
        v-events="{ eventsMap, ignoreEventName, args: ['mainTitle', data.mainTitle]}"
      >{{ data.mainTitle }}</div>
      <KyeReportCardQuestion
          class="fzkp001_main-icon"
          :icon="data.mainIcon"
          :popover="data.popover"
          @click="handleClick('mainIcon')">
          <slot :name="'tooltip'"></slot>
        </KyeReportCardQuestion>
    </div>
    <div class="fzkp001_main-cell-index">
      <div class="fzkp001_main-index-cell" @click="handleClick('mainIndex')">
        <div
          class="fzkp001_main-index"
          v-events="{ eventsMap, args: ['mainIndex', data.mainIndex]}"
        >{{ data.mainIndex }}</div>
        <div
          class="fzkp001_main-index-unit"
          v-events="{ eventsMap, args: ['mainIndexUnit', data.mainIndexUnit]}"
        >{{ data.mainIndexUnit }}</div>
      </div>
      <div class="fzkp001_order-cell-index">
        <div
          class="fzkp001_order-index-cell"
          :class="[`fzkp001_order-index-cell-${orderIndex}`]"
          v-for="(orderItem, orderIndex) in data.order"
          :key="orderIndex">
          <div
            class="fzkp001_order-title"
            @click="handleClick('orderTitle', orderIndex)"
            v-events="{ eventsMap, ignoreEventName, args: ['orderTitle', orderIndex, data.orderTitle]}"
          >{{ orderItem.orderTitle }}</div>
          <div
            class="fzkp001_order-index"
            @click="handleClick('orderIndex', orderIndex)"
            v-events="{ eventsMap, ignoreEventName, args: ['orderIndex', orderIndex, data.orderIndex]}"
          >{{ orderItem.orderIndex }}</div>
          <kyeReportCardArrow
            @click="handleClick('orderIcon', orderIndex)"
            class="fzkp001_order-icon"
            :type="orderItem.orderIcon"
            v-events="{ eventsMap, ignoreEventName, args: ['orderIcon', orderIndex, orderItem.orderIcon]}"
          ></kyeReportCardArrow>
        </div>
      </div>
      <div class="fzkp001_list-cell">
        <div class="fzkp001_list-title-cell">
          <div
            class="fzkp001_list-title"
            :class="[`fzkp001_list-title-${index}`]"
            v-for="(item, index) in data.list"
            :key="index"
            @click="handleClick('listTitle', index)"
            v-events="{ eventsMap, ignoreEventName, args: ['orderIndex', index, item.listTitle]}"
          >
            {{ item.listTitle }}
          </div>
        </div>
        <div class="fzkp001_list-index-cell-list">
          <div
            class="fzkp001_list-index-cell"
            :class="[`fzkp001_list-index-cell-${listIndex}`]"
            v-for="(listItem, listIndex) in data.list"
            :key="listIndex">
            <el-progress
              class="fzkp001_list-rate"
              :show-text="false"
              :color="listItem.listRateColor"
              :percentage="listItem.listRate"
              @click="handleClick('listRate', listIndex)"
              v-events="{ eventsMap, ignoreEventName, args: ['listRate', listIndex, listItem.listRate]}"
            ></el-progress>
            <div
              class="fzkp001_list-index"
              @click="handleClick('listIndex', listIndex)"
              v-events="{ eventsMap, ignoreEventName, args: ['listIndex', listIndex, listItem.listIndex]}"
            >{{ listItem.listIndex }}</div>
          </div>
        </div>
      </div>
    </div>
    <card-popover
      :popoverConfig="popoverConfig"
    >
      <slot :name="cardPopoverSlotName"></slot>
    </card-popover>
  </div>
</template>

<script>
import mainIcon1 from '../../asset/images/dgkp004.png'
import kyeReportCardArrow from '../common/arrow.vue'
import KyeReportCardQuestion from '../common/question.vue'
export default {
  name: 'KyeReportFzkp001',
  components: {
    KyeReportCardQuestion,
    kyeReportCardArrow
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      mainIcon1
    }
  },
  mounted() {
  },
  methods: {
    handleClick(eventName, index) {
      if (Number(index) >= 0) {
        this.$emit(eventName, index, this.data)
      } else {
        this.$emit(eventName, this.data)
      }
    },
    getIndexColor(type) {
      if (type === 'up') {
        return 'index-up-color'
      } else if (type === 'down') {
        return 'index-down-color'
      }
    }
  }
}
</script>

<style lang="scss">
.kye-report-fzkp001 {
  @import '../../style/extend.scss';
  background: #FFFFFF;
  border-radius: 4px;
  flex-direction: column;
  cursor: pointer;
  display: flex;
  .fzkp001_main-cell-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #F3F3FD;
    color: #333333;
    font-weight: 600;
    font-size: 12px;
    padding: 6px 12px;
    gap: 4px;
    .fzkp001_main-icon {
      width: 12px;
      height: 12px;
    }
  }
  .fzkp001_main-cell-index {
    display: flex;
    flex-direction: column;
    padding: 16px;
    .fzkp001_main-index-cell {
      display: flex;
      flex-direction: row;
      color: var(--g-color-primary);
      font-weight: 600;
      .fzkp001_main-index {
        font-size: 22px;
        line-height: 22px;
      }
      .fzkp001_main-index-unit {
        font-size: 12px;
        line-height: 12px;
        display: flex;
        flex-direction: column-reverse;
      }
    }
    .fzkp001_order-cell-index {
      display: flex;
      flex-direction: row;
      gap: 16px;
      margin-top: 16px;
      align-items: center;
      .fzkp001_order-index-cell {
        font-size: 12px;
        display: flex;
        align-items: center;
        flex-direction: row;
        color: #999999;
        .fzkp001_order-index {
          margin-left: 8px;
          color: #666666;
        }
      }
    }
    .fzkp001_list-cell {
      margin-top: 24px;
      display: flex;
      flex-direction: row;
      gap: 6px;
      .fzkp001_list-title-cell {
        display: flex;
        flex-direction: column;
        gap: 10px;
        max-width: 80px;
        line-height: 16px;
        width: max-content;
      }
      .fzkp001_list-index-cell-list {
        display: flex;
        flex-direction: column;
        gap: 10px;
        flex: 1;
        .fzkp001_list-index-cell {
          display: flex;
          flex-direction: row;
          align-items: center;
          line-height: 16px;
          .fzkp001_list-rate {
            flex: 1;
            display: flex;
            margin-left: 12px;
            flex-direction: row;
            align-items: center;
          }
          .fzkp001_list-index {
            margin-left: 10px;
            width: 40px;
            font-size: 12px;
            color: #333333;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/fzkp001/index.vue